import React from "react"
import PropTypes from "prop-types"
import dayjs from "dayjs"

import NavbarView from "../views/NavbarView"
import FooterView from "../views/FooterView"

import "../styles/global.css"
import "../styles/theme.css"

const Layout = ({ children, on_menu_button_click, location }) => {
  const now = dayjs()
  const year = now.format('YYYY')

  return (
    <>
      <div className="wrapper">
        <NavbarView on_menu_button_click={on_menu_button_click} />
        { children }
        <FooterView year={year} />
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
